import { render } from "./BillingAddressCartB2C.vue?vue&type=template&id=2a8375a8"
import script from "./BillingAddressCartB2C.vue?vue&type=script&lang=js"
export * from "./BillingAddressCartB2C.vue?vue&type=script&lang=js"

import "./BillingAddressCartB2C.vue?vue&type=style&index=0&id=2a8375a8&lang=css"

import exportComponent from "C:\\Ecommerce\\Studio Sport\\ECM_HYBRID_STUDIO_SPORT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__